import React from 'react';
import ColorPicker from 'rc-color-picker';
import Popover, { Alignment } from '~/App/Components/Popover';
import { theme } from '@vimily/bonjoro-ui-components';
import cx from 'classnames';

export enum PopoverPlaceType {
  Above = 'above',
  Right = 'right',
  Below = 'below',
  Left = 'left',
  Row = 'row',
  Column = 'column',
  Start = 'start',
  End = 'end',
}

export interface ColorPickerArgs {
  color: string;
  alpha: string;
}

export interface ColorPickerPopoverProps {
  open: boolean;
  enableAlpha?: boolean;
  preferPlace?: PopoverPlaceType;
  alignment?: Alignment;
  defaultColor?: string;
  pickerClassName?: string;
  popOverClassName?: string;
  children?: React.ReactNode;
  onOutsideClick?: () => void;
  onColorSelect?: (color: string) => void;
}

export default function ColorPickerPopover({
  open,
  enableAlpha = false,
  preferPlace = PopoverPlaceType.Below,
  alignment = Alignment.Middle,
  defaultColor = theme.colors.white,
  pickerClassName,
  popOverClassName,
  onOutsideClick,
  onColorSelect,
  children,
}: ColorPickerPopoverProps) {
  return (
    <Popover
      preferPlace={preferPlace}
      align={alignment}
      isOpen={open}
      onOuterAction={onOutsideClick}
      className={cx('z-99', popOverClassName)}
      body={
        <ColorPicker.Panel
          className={cx('mb-10', pickerClassName)}
          onChange={(args: ColorPickerArgs) => {
            onColorSelect?.(args.color);
          }}
          enableAlpha={enableAlpha}
          defaultColor={defaultColor}
        />
      }
    >
      {children}
    </Popover>
  );
}
